// import Vue from 'vue';
import Vuex from 'vuex';
import topic from './topic'
import Tiku from './Tiku'
import my from './my'
import event from './event'
Vue.use(Vuex);
const store = new Vuex.Store({
    // state,mutations,actions
    state: {//要设置的全局访问的state对象
        showFooter: true,
        changableNum: 0,
        innerHeight: window.innerHeight,
        loginStatus: false,//通过watch监控登陆状态，登陆后刷新数据
        //要设置的初始属性值
        commentSet: {
            show: false,
            update: 0,
            data: {}
        },
    },
    mutations: {
        // 处理状态
        increment(state, payload) {
            state.changableNum += payload || 1;
        },
        setHeight: (state, height) => {
            state.innerHeight = height
        },
        setloginStatus: (state, b) => {
            state.loginStatus = b
        },
        setCommentSetShow: (state, data) => {
            state.commentSet = data
        }
        ,
    },
    getters: {
        getCommentSetShow: (state) => {
            return state.commentSet
        },
        getHeight: (state) => {
            return `height:${state.innerHeight}px;`
        },
        getloginStatus: (state) => {
            return state.loginStatus;
        },
    },
    actions: {
        increment(context, data) {
            context.commit('increment', data)
        }
    },
    modules: { topic, Tiku, my, event }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js